<template>
  <Layout>
    <div class="statistics-report-main">

      <b-tabs content-class="tab-content-zone text-muted" nav-class="nav-tabs-custom"
              v-model="tabIndex"
              :class="{'nav-justified':$store.state.layout.browserMode === 'mobile'}">
        <template v-for="(tab, i) in tabs">
          <b-tab :key="i" :active="i === 0" @click="loadTab(i)">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i :class="`mdi ${tab.icon}`" />
              </span>
              <span class="d-none d-sm-inline-block">
                <i :class="`mdi ${tab.icon} icon-padding-right`" />
              </span>
              <span class="d-none d-sm-inline-block">{{ tab.title }}</span>
            </template>
            <keep-alive>
              <component :is="tab.component" :key="i"
                         v-if="loadedTabs.includes(i)" />
<!--              <component :is="tab.component" :key="i" :lazy="true" />-->
            </keep-alive>
          </b-tab>
        </template>
      </b-tabs>

    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main';
import StationStat from '@/views/pages/statistics/station.vue';
import StationReport from '@/views/pages/statistics/stationReport.vue';
import UserStat from '@/views/pages/statistics/user.vue';
import UserReport from '@/views/pages/statistics/userReport.vue';
import EventBus from "@/views/layouts/event-bus";

export default {
  components: { Layout, StationStat, StationReport, UserStat, UserReport },
  data() {
    return {
      loadedTabs: [0],
      tabIndex: null,
      tabs: [
        { title: '충전소 통계', icon: 'mdi-office-building-marker-outline', component: 'StationStat' },
        { title: '충전소 리포트', icon: 'mdi-clipboard-text-multiple-outline', component: 'StationReport' },
        { title: '이용자 통계', icon: 'mdi-account-supervisor', component: 'UserStat' },
        { title: '이용자 리포트', icon: 'mdi-clipboard-text-multiple-outline', component: 'UserReport' }
      ]
    }
  },
  created() {
    const vm = this;

    EventBus.$on('go-to-user-report', (month, userId) => {
      vm.loadTab(3)
      vm.tabIndex = 3;
    } )

    setTimeout(() => {
      vm.loadedTabs.push(2, 3);
    }, 2000);
  },
  onBeforeUnmount() {
    EventBus.$off('go-to-user-report');
  },
  methods: {
    loadTab(index) {
      const vm = this;

      if (!vm.loadedTabs.includes(index)) {
        vm.loadedTabs.push(index);
      }
    }
  }
}
</script>
